module.exports = __webpack_public_path__ + "static/img/weather44.990cea6f.png";